import React from "react";
import { Button, Modal, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const DeleteModal = ({ open, onClose, onConfirm, cFileName }) => {
  const { t } = useTranslation();

  const modalStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const paperStyle = {
    backgroundColor: "#ffffff",
    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
    padding: "20px",
    textAlign: "center",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-modal-title"
      aria-describedby="confirmation-modal-description"
      style={modalStyle}
    >
      <Box sx={{ ...paperStyle, width: "400px", height: "200px" }}>
        <Typography variant="h6" gutterBottom>
          {t("img_del_msg")} {cFileName}?
        </Typography>

        <Box sx={{ mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={onConfirm}
            style={{ marginRight: "20px" }}
          >
            {t("confirm")}
          </Button>
          <Button variant="contained" color="secondary" onClick={onClose}>
            {t("cancel")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteModal;
